import React, { forwardRef } from 'react'

import { IconProps } from './types'

const FileArchive = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.33331 12V13.3333M5.99998 12V10.6667M7.33331 10.6667V9.33333M5.99998 9.33333V8M8.66665 2.33333V6H12.3333M3.33331 2V14H12.6666V5.66667L8.99998 2H3.33331Z"
        stroke={color || 'currentColor'}
      />
    </svg>
  ),
)
FileArchive.displayName = 'FileArchive'

export default FileArchive
